"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;

var react_1 = __importDefault(require("react"));

var Label_styles_1 = require("./Label.styles");

var Label = function Label(_a) {
  var error = _a.error,
      label = _a.label,
      htmlFor = _a.htmlFor,
      _b = _a.errorShouldReplaceLabel,
      errorShouldReplaceLabel = _b === void 0 ? false : _b,
      props = __rest(_a, ["error", "label", "htmlFor", "errorShouldReplaceLabel"]);

  return react_1.default.createElement(Label_styles_1.StyledLabel, __assign({
    htmlFor: htmlFor,
    "data-testid": "".concat(htmlFor, "_label"),
    "data-error": !!error,
    error: error
  }, props), errorShouldReplaceLabel ? error ? error : label : react_1.default.createElement(react_1.default.Fragment, null, label, error && ": ".concat(error)));
};

exports.Label = Label;